var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tooltip",
    { staticClass: "item", attrs: { effect: "dark", placement: "bottom" } },
    [
      _c("div", { attrs: { slot: "content" }, slot: "content" }, [
        _c(
          "div",
          {
            staticClass: "flex items-center",
            staticStyle: { "margin-bottom": "12px" },
          },
          [
            _c("div", [_vm._v("字段类型：" + _vm._s(_vm.tableFieldTypeName))]),
            _vm._v(" "),
            _c("div", { staticStyle: { "margin-left": "24px" } }, [
              _c("span", [_vm._v("字段属性：")]),
              _vm._v(" "),
              !_vm.isEmpty(_vm.data.fieldLength)
                ? _c("span", [
                    _vm._v("字段长度" + _vm._s(_vm.data.fieldLength)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isEmpty(_vm.data.fieldPrecision)
                ? _c("span", { staticStyle: { "margin-left": "4px" } }, [
                    _vm._v("字段精度" + _vm._s(_vm.data.fieldPrecision)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.isEmpty(_vm.data.fieldLength) &&
              _vm.isEmpty(_vm.data.fieldPrecision)
                ? _c("span", [_vm._v("-")])
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", [
          _vm._v("字段说明：" + _vm._s(_vm.data.fieldRemarks || "-")),
        ]),
      ]),
      _vm._v(" "),
      _c("i", {
        class: [
          "iconfont",
          _vm.getFieldIcon(_vm.data.fieldType),
          "mr8",
          { "is-primary-icon": _vm.data.isPrimary },
        ],
        staticStyle: { "font-size": "12px" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }